/* @flow */

import React from 'react';
import {Link} from 'react-router-dom';

import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

import ButtonComponent from 'components/buttons/button';
import FormErrorsComponent from 'components/formErrors';
import IntlMessageComponent from 'components/formatters/intlMessage';
import CompanyLookupReset2FAComponent from 'components/companyLookupV2/reset2fa';

import Reset2FAForm from './model';

import {SIGN_IN} from 'constants/pageRoutes';

type Reset2FAViewComponentProps = {
  errors: Map<string, ?string>;
  form: Reset2FAForm;
  formErrors: string[];
  isProcessing: boolean;
  handleCompanySelect: (company: any) => void;
  handleEmailChange: (event: any) => void;
  handlePasswordChange: (event: any) => void;
  submitForm: () => void;
}

export default function Reset2FAViewComponent(props: Reset2FAViewComponentProps) {
  return (
    <React.Fragment>
      <FormErrorsComponent formErrors={props.formErrors} />

      <Box mt={3}>
        <Typography variant="body1">
          <IntlMessageComponent id="twofactor.reset.text" />
        </Typography>
      </Box>

      <Box mt={3}>
        <Typography variant="h5" color="primary">
          <IntlMessageComponent id="twofactor.reset.subtitle.company" />
        </Typography>
      </Box>

      <Box mt={2}>
        <CompanyLookupReset2FAComponent
          company={props.form.company}
          companyErrorLabelId={props.errors.get('company') || ''}
          required
          handleSelect={props.handleCompanySelect}
        />
      </Box>

      <Box mt={3}>
        <Typography variant="h5" color="primary">
          <IntlMessageComponent id="twofactor.reset.subtitle.login" />
        </Typography>
      </Box>

      <Box mt={1}>
        <TextField
          id="form.reset2fa.email"
          label={<IntlMessageComponent id="appModule.name" />}
          error={!!props.errors.get('email')}
          helperText={props.errors.get('email') ? <IntlMessageComponent id={props.errors.get('email')} /> : ''}
          value={props.form.email}
          onChange={props.handleEmailChange}
          fullWidth
          margin="normal"
        />

        <TextField
          id="form.reset2fa.password"
          label={<IntlMessageComponent id="appModule.password" />}
          error={!!props.errors.get('password')}
          helperText={props.errors.get('password') ? <IntlMessageComponent id={props.errors.get('password')} /> : ''}
          value={props.form.password}
          onChange={props.handlePasswordChange}
          type="password"
          fullWidth
          margin="normal"
        />
      </Box>

      <Box mt={4}>
        <ButtonComponent
          color="default"
          variant="contained"
          component={Link}
          to={SIGN_IN}
        ><IntlMessageComponent id="general.cancel" /></ButtonComponent>

        <Box component="span" ml={1}>
          <ButtonComponent
            color="primary"
            variant="contained"
            isProcessing={props.isProcessing}
            onClick={props.submitForm}
          ><IntlMessageComponent id="twofactor.reset.confirm" /></ButtonComponent>
        </Box>
      </Box>
    </React.Fragment>
  );
}
